import React, { useEffect, useState } from "react";
import { getPlan, updatePlan } from "../api/postPlansApi";
import { Box, Paper, Stack, TextField, MenuItem, Button, Alert, Typography } from "@mui/material";

const WD_5 = ["Mon","Tue","Wed","Thu","Fri"];
const WD_6 = ["Mon","Tue","Wed","Thu","Fri","Sat"];

export default function StepConstraints({ planId, registerSave }) {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  const [maxPerDay, setMaxPerDay] = useState(1);   // max turni stesso ruolo nello stesso giorno
  const [turniSett, setTurniSett] = useState(5);   // 5 (L–V) o 6 (L–S)
  const [continuity, setContinuity] = useState(0.6);

  useEffect(() => {
    (async () => {
      try {
        const p = await getPlan(planId);
        const c = p.constraints || {};
        setMaxPerDay(Number(c.max_turns_per_day ?? 1));
        setContinuity(Number(c.continuity_preference ?? 0.6));
        const wd = p.working_days || WD_5;
        setTurniSett(wd.includes("Sat") ? 6 : 5);
      } catch (e) {
        setErr(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [planId]);

  const onSave = async () => {
  try {
    setErr(null);
    const working_days = turniSett === 6 ? WD_6 : WD_5;
    await updatePlan(planId, {
      working_days,
      constraints: {
        max_turns_per_day: Number(maxPerDay),
        max_turns_per_week: Number(turniSett),
        continuity_preference: Number(continuity),
        per_role: {}
      }
    });
    return true;
  } catch (e) {
    setErr(e.message);
    alert(e.message || "Errore salvataggio vincoli");
    return false;
  }
};


  // ► collega il footer del wizard
  useEffect(() => {
    if (!registerSave) return;
    registerSave(async () => await onSave());
  }, [registerSave, maxPerDay, turniSett, continuity]);

  if (loading) return <Box p={2}>Caricamento…</Box>;

  return (
    <Box>
      <Paper variant="outlined">
        <Box p={2}>
          {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}

          <Typography variant="subtitle1" gutterBottom>Regole generali di programmazione</Typography>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mb={2}>
            <TextField
              type="number"
              label="Max turni/giorno (per ruolo)"
              value={maxPerDay}
              onChange={(e)=> setMaxPerDay(Number(e.target.value))}
              helperText="Quanti turni dello stesso ruolo possono cadere nello stesso giorno"
              sx={{ minWidth: 260 }}
            />
            <TextField
              select
              label="Turni a settimana"
              value={turniSett}
              onChange={(e) => setTurniSett(Number(e.target.value))}
              helperText={turniSett === 5 ? "Lunedì–Venerdì" : "Lunedì–Sabato"}
              sx={{ minWidth: 220 }}
            >
              <MenuItem value={5}>5 (L–V)</MenuItem>
              <MenuItem value={6}>6 (L–S)</MenuItem>
            </TextField>
            <TextField
              type="number"
              inputProps={{ step: "0.05", min: 0, max: 1 }}
              label="Continuity preference (0–1)"
              value={continuity}
              onChange={(e)=> setContinuity(Number(e.target.value))}
              helperText="Più è alto, più il motore cerca continuità sugli stessi nominativi"
              sx={{ minWidth: 280 }}
            />
          </Stack>

          <Button variant="contained" onClick={onSave}>Salva</Button>
        </Box>
      </Paper>
    </Box>
  );
}
